import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BatchPredictionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"batch_prediction"}/>
}
